<template>
    <div class="homepage">
        <nav-bar />
        <search-bar />
        <router-view class="" />
        <footer-bar />
    </div>
</template>

<script>
    import NavBar from "@/components/NavBar";
    import SearchBar from "@/components/SearchBar";
    import FooterBar from "@/components/FooterBar";
    export default {
        props: {},
        data() {
            return {

            };
        },
        computed: {},
        created() {},
        mounted() {},
        watch: {},
        methods: {},
        components: {
            "nav-bar": NavBar,
            "search-bar": SearchBar,
            "footer-bar": FooterBar
        }
    };
</script>

<style scoped lang="scss">
    .homepage {
        width: 100%;
        height: 100vh;
        overflow-y: scroll;
        .nav_box {
            width: 100%;
            background-color: #fff;
            .home_navbar {
                margin: 0 auto;
                width: 100%;
                height: 60px;
                .nav_item {
                    width: 160px;
                    height: 100%;
                    position: relative;
                    .line {
                        width: 50%;
                        height: 2px;
                        position: absolute;
                        left: 0;
                        right: 0;
                        bottom: 10%;
                        margin: auto;
                        background-color: #458ef6;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/register/index.vue